"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IconType;
(function (IconType) {
    IconType["None"] = "None";
    IconType["AddGreen"] = "AddGreen";
    IconType["Add"] = "Add";
    IconType["AddMore"] = "AddMore";
    IconType["AlertSuccess"] = "AlertSuccess";
    IconType["ArrowLeft"] = "ArrowLeft";
    IconType["ArrowRight"] = "ArrowRight";
    IconType["BoxBubble"] = "BoxBubble";
    IconType["Box"] = "Box";
    IconType["Calendar"] = "Calendar";
    IconType["Camera"] = "Camera";
    IconType["CancelBubble"] = "CancelBubble";
    IconType["Cancel"] = "Cancel";
    IconType["Car"] = "Car";
    IconType["CategoryCreditCard"] = "CategoryCreditCard";
    IconType["CategoryFragile"] = "CategoryFragile";
    IconType["CategoryHouse"] = "CategoryHouse";
    IconType["CategoryLift"] = "CategoryLift";
    IconType["CategoryPeople"] = "CategoryPeople";
    IconType["CategoryWeight"] = "CategoryWeight";
    IconType["Check"] = "Check";
    IconType["ChevronDown"] = "ChevronDown";
    IconType["ChevronLeft"] = "ChevronLeft";
    IconType["ChevronRight"] = "ChevronRight";
    IconType["ChevronUp"] = "ChevronUp";
    IconType["Clock"] = "Clock";
    IconType["Coin"] = "Coin";
    IconType["Comment"] = "Comment";
    IconType["Csv"] = "Csv";
    IconType["Document"] = "Document";
    IconType["Download"] = "Download";
    IconType["Driver"] = "Driver";
    IconType["Edit"] = "Edit";
    IconType["Email"] = "Email";
    IconType["Error"] = "Error";
    IconType["Facebook"] = "Facebook";
    IconType["Filter"] = "Filter";
    IconType["Gallery"] = "Gallery";
    IconType["Garbage"] = "Garbage";
    IconType["Google"] = "Google";
    IconType["HamburgerMenu"] = "HamburgerMenu";
    IconType["Help"] = "Help";
    IconType["Hide"] = "Hide";
    IconType["HomeGreen"] = "HomeGreen";
    IconType["Home"] = "Home";
    IconType["Information"] = "Information";
    IconType["Instagram"] = "Instagram";
    IconType["Integration"] = "Integration";
    IconType["Invoice"] = "Invoice";
    IconType["Lift"] = "Lift";
    IconType["LinkedIn"] = "LinkedIn";
    IconType["Location"] = "Location";
    IconType["LocationWhiteBg"] = "LocationWhiteBg";
    IconType["Lock"] = "Lock";
    IconType["Logout"] = "Logout";
    IconType["Measure"] = "Measure";
    IconType["MissedRed"] = "MissedRed";
    IconType["Mix"] = "Mix";
    IconType["More"] = "More";
    IconType["Notification"] = "Notification";
    IconType["Organize"] = "Organize";
    IconType["Pallet"] = "Pallet";
    IconType["Pdf"] = "Pdf";
    IconType["People"] = "People";
    IconType["Phone"] = "Phone";
    IconType["Preferences"] = "Preferences";
    IconType["Route"] = "Route";
    IconType["Search"] = "Search";
    IconType["Show"] = "Show";
    IconType["Sofa"] = "Sofa";
    IconType["StatusActive"] = "StatusActive";
    IconType["StatusDefault"] = "StatusDefault";
    IconType["StatusMissed"] = "StatusMissed";
    IconType["StatusSuccess"] = "StatusSuccess";
    IconType["Suitcase"] = "Suitcase";
    IconType["Telephely"] = "Telephely";
    IconType["Template"] = "Template";
    IconType["TikTok"] = "TikTok";
    IconType["TruckBubble"] = "TruckBubble";
    IconType["TruckGreen"] = "TruckGreen";
    IconType["Truck"] = "Truck";
    IconType["Upload"] = "Upload";
    IconType["User"] = "User";
    IconType["Web"] = "Web";
    IconType["Weight"] = "Weight";
    IconType["Youtube"] = "Youtube";
})(IconType || (IconType = {}));
exports.default = IconType;
